import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { withAuthentication } from "hocs/withAuthentication";
import RequestCard from "./RequestCard";
import {
    Title,
    ButtonWrapper,
    HeaderWrapper,
    FilterWrapper,
    EmptyViewWrapper,
} from "./styled";
import { Space, Loader } from "components";
import { filters } from "./consts";
import { ReactComponent as PlusIcon} from "assets/svgs/plus.svg";
import Layout from "../Layout";
import { getWORequests } from "./service";

const Filters = ({match, counts}) => {
    let allCount = 0;
    if (!counts){
        counts = {};
    }
    for(let i=0; i < Object.keys(counts).length; i++) {
        allCount += counts[Object.keys(counts)[i]];
    }

    return Object.keys(filters).map((filter, i) =>
        <NavLink key={i} to={`/${match.params.id}/work-orders/show/${filter}`}
                 activeClassName="active">
            <span>{counts && filter !== 'all' ? counts[filters[filter]] : allCount}</span>
            {/* intentional space for text-transform: capitalize to work*/}
            &nbsp;{filter}
        </NavLink>
    );
};

const EmptyView = () =>
    <EmptyViewWrapper>
        No Work Order Requests Found
    </EmptyViewWrapper>;

const Requests = ({ requests }) =>
    requests.map((req, i) => <RequestCard key={i} request={req}/>);

const RequestsView = ({roleId, email, ...props}) => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);

    const [statusFilter, setStatusFilter] = useState(filters[props.match.params.filter]);
    useEffect(() => {
        if (statusFilter === props.match.params.filter) {
            return;
        }

        // prevent un-necessary renders due to change in match
        // kind of cache implementation for `props.match.params.filter`
        setStatusFilter(filters[props.match.params.filter]);
    }, [statusFilter, props.match.params.filter]);

    useEffect(() => {
        setLoading(true);
        getWORequests(roleId, email, statusFilter)
            .then(setRequests)
            .then(() => setLoading(false));
    }, [roleId, email, statusFilter]);

    return <Layout>
        <HeaderWrapper>
            <Title>My Work Order Requests</Title>
            <Link to={`/${roleId}/work-orders/create`}>
                <ButtonWrapper>
                    <PlusIcon/>
                    <span>Work Order Request</span>
                </ButtonWrapper>
            </Link>
        </HeaderWrapper>

        <Space/>
        <FilterWrapper>
            <Filters match={props.match} counts={requests.counts}/>
        </FilterWrapper>

        <Space/>
        { loading && <Loader/> }
        { !loading && requests.results.length === 0 && <EmptyView/> }
        { !loading && requests.results.length !== 0 && <Requests requests={requests.results} /> }
    </Layout>;
};

export default withAuthentication(RequestsView);
